import {query} from "@/graphql/client";
import {gql} from "@urql/vue";
import {
    IbfgExcessShareSzenario,
    IbfgMonthlyFinancialResultSummary,
    IbfgYearlyFinancialResultSummary
} from "@/graphql/generated/graphql";
import {CalendarMonth} from "@/helper/calendar/calendarMonth";
import { clientFragment, houseFragment } from "../jobsite";
import { jobsiteFragment } from "../jobsite";
import {kapitelDateString, kapitelMonthString} from "@/graphql/kapitelTypes";
import {moneyFragment} from "@/helper/money";
import date from "@/helper/datetime/date";
import {graphql} from "@/graphql/generated";

/**
 cumsum  {...MoneyFragment}
 * - IBFG earnings result monthly (result) & cumulative (cumsum)
 * - my share as total (excessShare) & hourly (hourlyPlusByExcessShare)
 *
 */
export const ibfgMonthlyFinancialResultFragment = graphql(` fragment IbfgMonthlyFinancialResultFragment on IbfgMonthlyFinancialResultSummary {    
    month
    cntActiveEmployees
    kapitelLicenseCost {...MoneyFragment}
    overheadCost {...MoneyFragment}
    pk1 {...MoneyFragment}
    result {...MoneyFragment}
    revenue {...MoneyFragment}
    totalCost {...MoneyFragment}
}`)
export const ibfgYearlyFinancialResultFragment = graphql(`  fragment IbfgYearlyFinancialResultFragment on IbfgYearlyFinancialResultSummary {    
    # result
    monthlyResults {
        ...IbfgMonthlyFinancialResultFragment
    }
    cumSumResults  {...MoneyFragment}
    
    # my share    
    myExcessShare  {...MoneyFragment}
    myHourlyPlusByExcessShare  {...MoneyFragment}
    # my share info
    myCumSumDB1 {...MoneyFragment}
    myProductiveHours
    myShareRatio
    
    
    # additional data
    lastMonthIncluded    
    year
}`)

export async function fetchIbfgFinancialResultToDate(month: kapitelMonthString): Promise<IbfgYearlyFinancialResultSummary> {
    const result = await query(
        graphql(`
            query getIbfgFinancialResultToDate($month: KapitelDateImmutable!) {            
            financialResultToDate(month: $month) {
                ...IbfgYearlyFinancialResultFragment
            }
        }`),
        {month}
    )

    return result.data.financialResultToDate
}

export async function fetchIbfgFinancialResultSzenarios(month: kapitelMonthString): Promise<IbfgExcessShareSzenario[]> {
    const result = await query(
        graphql(`
            query ibfgFinancialResultSzenarios($month: KapitelDateImmutable!) {            
            ibfgFinancialResultSzenarios(month: $month) {
                virtualEmployeeCount
                cumSumResults {...MoneyFragment}
                myExcessShare {...MoneyFragment}
                myHourlyPlusByExcessShare {...MoneyFragment}
            }
        }`),
        {month}
    )

    return result.data.ibfgFinancialResultSzenarios
}


export function monthlyResultsSorter(a : IbfgMonthlyFinancialResultSummary, b : IbfgMonthlyFinancialResultSummary) {
    return date.cmpKapitelDate(a.month, b.month)
}

export function getLastIncludedMonthlyResult(yearlySummary: IbfgYearlyFinancialResultSummary): IbfgMonthlyFinancialResultSummary | undefined {
    return yearlySummary.monthlyResults.find((mr) => mr.month === yearlySummary.lastMonthIncluded )
}
